import React from 'react';
export function PivotSection() {
  return <section className="py-24 px-4 bg-brand-purple text-center" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <p className="text-brand-yellow font-bold text-xl md:text-2xl mb-6" data-id="element-148">
          La buena noticia:
        </p>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-149">
          Con el sistema correcto, <br className="hidden md:block" data-id="element-150" /> 20 minutos
          alcanzan.
        </h2>
        <p className="text-xl md:text-2xl text-brand-purpleLight font-medium max-w-2xl mx-auto" data-id="element-151">
          Tu air fryer es la herramienta perfecta. Solo le faltaban las
          instrucciones correctas para alguien que no necesita experiencia
          previa.
        </p>
      </div>
    </section>;
}